<template>
  <div>
    <!-- <a :href="jobHref" :target="target" class="joboffer-list-item__wrapper"> -->

    <template v-if="this.showExternalAdvert">
      <a :href="jobHref" target="_blank" class="joboffer-list-item__wrapper">
        <div class="joboffer-box">
          <v-row no-gutters>
            <v-col cols="11">
              <div>
                <h3>
                  <span v-if="isFieldEnabled('job-code')">
                    {{ joboffer.jobCode }} &mdash;
                  </span>
                  {{ jobName }}
                </h3>
              </div>
              <div class="d-block d-sm-flex flex-sm-wrap mt-4 text-sm">
                <item-field
                  v-for="field in jobDataFields"
                  :key="`job-item_${field}`"
                  :joboffer="joboffer"
                  :field="field"
                ></item-field>
              </div>
            </v-col>
            <v-col cols="1" class="d-flex align-center justify-end text-right">
              <v-icon color="accent">mdi-chevron-right</v-icon>
            </v-col>
          </v-row>
        </div>
      </a>
    </template>
    <template v-else>
      <a
        :href="absoluteJobHref"
        class="joboffer-list-item__wrapper"
        @click="navigateToJob"
      >
        <div class="joboffer-box">
          <v-row no-gutters>
            <v-col cols="11">
              <div>
                <h3>
                  <span v-if="isFieldEnabled('job-code')">
                    {{ joboffer.jobCode }} &mdash;
                  </span>
                  {{ jobName }}
                </h3>
              </div>
              <div class="d-block d-sm-flex flex-sm-wrap mt-4 text-sm">
                <item-field
                  v-for="field in jobDataFields"
                  :key="`job-item_${field}`"
                  :joboffer="joboffer"
                  :field="field"
                ></item-field>
              </div>
            </v-col>
            <v-col cols="1" class="d-flex align-center justify-end text-right">
              <v-icon color="accent">mdi-chevron-right</v-icon>
            </v-col>
          </v-row>
        </div>
      </a>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import itemField from './joboffer-item-fields/item-field.vue';

export default {
  props: {
    joboffer: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState('companyModule', {
      showExternalAdvert: 'showExternalAdvert',
      jobDataFields: 'jobDataFields'
    }),

    ...mapGetters('companyModule', {
      isInternal: 'userIsInternal'
    }),

    ...mapState({
      currentLanguage: 'currentLanguage'
    }),

    absoluteJobHref() {
      return window.location.origin + this.jobHref;
    },

    jobHref() {
      if (this.showExternalAdvert) {
        return `${this.joboffer.advertUrl}?lang=${this.currentLanguage}`;
      } else {
        return this.$router.resolve({
          name: 'jobDetails',
          params: {
            jobId: this.joboffer.jobofferId,
            jobName: 'joboffer-name'
          }
        }).href;
      }
    },

    jobName() {
      return this.isInternal
        ? this.localize(this.joboffer.internalName) || this.localize(this.joboffer.name)
        : this.localize(this.joboffer.name);
    },

    target() {
      if (this.showExternalAdvert) {
        return '_blank';
      } else {
        return '_self';
      }
    }
  },

  methods: {
    navigateToJob(event) {
      if (this.shouldOpenInNewTab(event) || this.showExternalAdvert) {
        return;
      }

      event?.preventDefault?.();
      this.$router.push({
        name: 'jobDetails',
        params: {
          jobId: this.joboffer.jobofferId,
          jobName: 'joboffer-name'
        }
      });
    },

    shouldOpenInNewTab(event) {
      return (
        !event ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.button === 1 ||
        event.altKey
      );
    },

    isFieldEnabled(fieldName) {
      return this.jobDataFields.includes(fieldName);
    }
  },

  components: {
    itemField
  }
};
</script>

<style scoped>
.joboffer-box:hover {
  cursor: pointer;
}

a.joboffer-list-item__wrapper {
  color: inherit;
  text-decoration: none;
}

h3 {
  font-family: var(--font-family) !important;
  font-weight: 700 !important;
  font-size: 1rem !important;
  line-height: 1.5 !important;
  margin-bottom: 0 !important;
}
</style>
